import React from "react";

function Walletbankdetails({ bankDetail }) {
  const ignoredKeys = ["_id", "createdAt", "updatedAt", "__v", "verified"]; // Add the keys you want to ignore here
  const keyMapping = {
    "Account Number": "accountNo",
    "IFSC code": "IFCSCode",
    "Bank Name": "bankName",
    "Account Holder's name": "holderName",
    "branch": "bankBranch",
  };

  const bankDetailsTable = Object.entries(bankDetail)
    .filter(([key]) => !ignoredKeys.includes(key))
    .map(([key, value]) => {
      // Adding the new key from the keyMapping
      const newKey = Object.keys(keyMapping).find((k) => keyMapping[k] === key);
      return { newKey: newKey || key, value: value };
    });

  return (
    <div className="">
      <div className="valign-wrapper space-between">
        <b className="font-20px">Bank Details</b>
        <span className="material-icons-outlined pointer modal-close">
          close
        </span>
      </div>
      <div className={`p-1 flex justify-center column`}>
        <div>
          <span
            className="valign-wrapper textAlign-start justify-center"
            style={{ gap: "10px" }}
          >
            <span>
              <b className="font-20px">
                {bankDetail.holderName}-{String(bankDetail.accountNo).slice(-5)}
              </b>
              <p className="cercle-purple-text">
                Your account is{" "}
                {bankDetail.verified ? "verified" : "not verified"}
              </p>
            </span>
            {bankDetail.verified && (
              <img
                src={`${process.env.PUBLIC_URL}/icons/Icon.svg`}
                alt="Icon"
                style={{ width: "25px", height: "25px" }}
              />
            )}
          </span>
          <div className="table-container mt-2 mb-2">
            <table className="custom-table">
              <tbody>
                {bankDetailsTable.map((row, index) => (
                  <tr key={index} style={{ display: "grid-2" }}>
                    <th>{row?.newKey}</th>
                    <td>{row?.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Walletbankdetails;
